<template>
  <b-modal
    title="Verify You're Human"
    body-bg-variant="light"
    header-bg-variant="dark"
    header-text-variant="white"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    centered
    v-model="isShown"
    @hidden="onHidden"
    @shown="onShown"
  >
    <p class="mb-3">Please complete the challenge below to continue.</p>
    <div ref="container" class="d-flex justify-content-center"></div>
  </b-modal>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { renderRecaptchaV2, resetRecaptchaV2 } from '@/util/recaptcha';

@Component
export default class RecaptchaV2Modal extends Vue {
  @Prop({ type: Boolean, default: false }) value;
  @Prop({ type: String, default: '' }) siteKey;

  isShown = false;
  widgetId = null;
  resolvedThisShow = false;

  @Watch('value', { immediate: true })
  onValueChange(val) {
    this.isShown = !!val;
  }

  @Watch('isShown')
  onShownChange(val) {
    this.$emit('input', val);
  }

  async onShown() {
    this.resolvedThisShow = false;
    if (!this.siteKey) {
      this.$emit('error', new Error('reCAPTCHA v2 site key not configured'));
      this.isShown = false;
      return;
    }
    try {
      const result = await renderRecaptchaV2(this.$refs.container, this.siteKey);
      if (!result) {
        this.$emit('error', new Error('Failed to load reCAPTCHA'));
        this.isShown = false;
        return;
      }
      this.widgetId = result.widgetId;
      this.resolvedThisShow = true;
      this.$emit('resolved', result.token);
      this.isShown = false;
    } catch (err) {
      this.$emit('error', err);
      this.isShown = false;
    }
  }

  onHidden() {
    if (this.widgetId !== null) {
      resetRecaptchaV2(this.widgetId);
    }
    if (!this.resolvedThisShow) {
      this.$emit('cancelled');
    }
  }
}
</script>
